module.exports = __webpack_public_path__ + "../resources/images/illustration_mention-afe18c75dae74bfc041c3012fa327ed7.svg";